import { getCSRFToken } from '@shared/cookie';

function request(url, opts) {
  const defaultOptions = {
    credentials: 'same-origin', // allow cookies to be sent
    headers: new Headers({
      'X-XSRF-TOKEN': getCSRFToken(), // always send the CSRF token header
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      accept: 'application/json, text/javascript, */*; q=0.01',
    }),
  };

  const options = Object.assign({}, defaultOptions, opts);

  return fetch(url, options).then(response => {
    if (response.ok) {
      return response.json();
    }

    throw new Error(response.statusText);
  });
}

export default function doPostRequest(data) {
  let url = '/ajax/table/project_contest_datatable.php?';
  url += Object.keys(data).reduce(
    (total, key) => `${total + key}=${encodeURIComponent(data[key])}&`,
    '',
  );
  const defaultOptions = {
    method: 'GET',
  };

  const options = Object.assign({}, defaultOptions);
  return request(url, options);
}
